import React, {
  useState,
  useCallback,
  useEffect,
  useLayoutEffect,
} from 'react';
import InputMask from 'react-input-mask';
import { useSelector, useDispatch } from 'react-redux';
import { Types } from 'mongoose';
import {
  Container,
  Title,
  List,
  TriggerDetails,
  TimeTrigger,
  MessageTrigger,
  SessionRule,
  TimeSettings,
  MessageSettings,
  AddRule,
  Save,
} from './styles';

import outlinePlus from '../../../../assets/images/icon_add_blue.svg';
import outlineDelete from '../../../../assets/images/icon_delete_red.svg';
import timeIcon from '../../../../assets/images/tempo.svg';
import timeActiveIcon from '../../../../assets/images/tempo_ativo.svg';
import triggerIcon from '../../../../assets/images/gatilho.svg';
import triggerActiveIcon from '../../../../assets/images/gatilho_ativo.svg';

import Select from '../../../Select';
import MenuVariaveis from '../../../MenuVariaveis';

import { TriggerActions } from '../../../../store/actions/triggers';

import triggerValidation from '../../../../util/triggerValidation';

function SettingsTab(props) {
  const triggerState = useSelector((state) => state.triggers);
  const itemState = useSelector((state) => state.items);
  const botState = useSelector((state) => state.bots.bot);
  const user = useSelector((state) => state.users?.signedUser);

  const dispatch = useDispatch();

  const [triggers] = useState(triggerState.triggers);
  const [inputValue, setInputValue] = useState({});
  const [values, setValues] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [viewer, setViewer] = useState(false);

  useEffect(() => {
    const itemBlock = itemState.list || props.item.list;

    const squares = itemBlock.map((square) => {
      return { value: square._id, label: `${square.title} ${square._id}` };
    });
    setDestinationOptions(squares);
  }, []);

  useEffect(() => {
    if (user.selectedCompany?.claim?.name === 'Viewer') {
      setViewer(true);
    }
  }, []);

  const handleFindTimeSelected = (squareId) => {
    const findSquare = destinationOptions.find(
      (square) => square.value === squareId
    );

    return findSquare;
  };

  const handleTriggerFindTimeSelected = (squareId) => {
    const findSquare = destinationOptions.find(
      (square) => square.value === squareId
    );

    return findSquare;
  };

  const handleChangeActivator = (triggerId, activator) => {
    const { changeActivator } = TriggerActions;

    dispatch(changeActivator(triggerId, activator));
  };

  const handleDeleteTrigger = (triggerId) => {
    const { deleteTrigger } = TriggerActions;

    dispatch(deleteTrigger(triggerId));
  };

  const handleInputChange = useCallback((triggerId, _value) => {
    setInputValue({ [triggerId]: _value });
  }, []);

  const handleChangeAction = (triggerId, action) => {
    const { changeAction } = TriggerActions;
    dispatch(changeAction(triggerId, action));
  };

  const handleUpdateMessage = (triggerId, message) => {
    const { updateMessage } = TriggerActions;

    dispatch(updateMessage(triggerId, message));
  };

  const handleUpdateSquareSelect = (triggerId, squareId) => {
    const { updateSquare } = TriggerActions;
    dispatch(updateSquare(triggerId, squareId));
  };

  const handleDeleteWord = (triggerId, wordArray) => {
    const { removeWord } = TriggerActions;

    if (wordArray === null) {
      dispatch(removeWord(triggerId, []));

      return;
    }
    const words = wordArray.map((word) => {
      return word.value;
    });

    dispatch(removeWord(triggerId, words));
  };

  const handleUpdateTimeInactive = (triggerId, time) => {
    const { updateInactivityTime } = TriggerActions;

    dispatch(updateInactivityTime(triggerId, time));
  };

  const updateTimeWithoutUserResponse = (time) => {
    console.log(time);

    const { updateTimeWithoutResponse } = TriggerActions;
    dispatch(updateTimeWithoutResponse(time));
  };

  const handleSaveBot = () => {
    if (!viewer) {
      const { saveBotTriggers } = TriggerActions;
      const { _id: botId } = botState;
      const { triggers: currentTriggers, maxTimeWithoutResponse } =
        triggerState;

      const validation = triggerValidation(currentTriggers);

      if (!validation) {
        return;
      }

      dispatch(saveBotTriggers(botId, currentTriggers, maxTimeWithoutResponse));
    }
  };

  const handleCreateEmptyTrigger = () => {
    const { createEmptyTrigger } = TriggerActions;

    const objectId = Types.ObjectId().toString();

    dispatch(createEmptyTrigger(objectId));
  };

  const formatValues = (receivedValues) => {
    const formattedValue = receivedValues.map((value) => {
      return { value, label: value };
    });

    return formattedValue;
  };

  const handleKeyDown = useCallback(
    (triggerId, event) => {
      if (!inputValue) return;
      switch (event.key) {
        case 'Enter':
        case 'Tab':
          setInputValue({ [triggerId]: '' });
          const { addTriggerWord } = TriggerActions;

          const tagExists = values.find((tag) => tag.value === inputValue);
          if (tagExists) return;

          setValues([...values, { label: inputValue, value: inputValue }]);
          dispatch(addTriggerWord(triggerId, event.target.value));

          event.preventDefault();
          break;
        default:
          break;
      }
    },
    [dispatch, inputValue, values]
  );

  const handleSelectVariavel = (variavel, triggerId, message) => {
    const newMessge = `${message} {${variavel}}`;

    handleUpdateMessage(triggerId, newMessge);
  };

  const selectValue = [
    { value: 'message', label: 'Mensagem' },
    { value: 'square', label: 'Bloco' },
  ];

  return (
    <Container>
      <Title>
        <span>
          Configuração do Bot <strong>Rota de Fuga</strong>
        </span>

        <div className="description-container">
          <small>
            Tempo máximo sem resposta de usuário <br />
            para inicio de nova sessão:&nbsp;&nbsp;
            <img src={timeIcon} size={15} alt="timeIcon" />
            <InputMask
              onChange={(e) => {
                updateTimeWithoutUserResponse(e.target.value);
              }}
              value={triggerState.maxTimeWithoutResponse || ''}
              placeholder="HH:MM"
              mask="99:99"
            />
            &nbsp;(hh:mm)
          </small>
        </div>
      </Title>

      <List>
        {triggers
          .filter((trigger) => trigger.version === 0)
          .map((trigger, index) => (
            <TriggerDetails key={trigger._id}>
              {trigger.activator === '' || undefined || null ? (
                <SessionRule>
                  <div className="delete-rule-container">
                    <strong>Regra de sessão {index + 1}:</strong>
                    <img
                      onClick={() => {
                        handleDeleteTrigger(trigger._id);
                      }}
                      src={outlineDelete}
                      size={22}
                      alt="delete-rule"
                    />
                  </div>
                  <div className="activators-container">
                    <small>Ativador</small>
                    <div className="buttons">
                      <button
                        onClick={() =>
                          handleChangeActivator(trigger._id, 'time')
                        }
                        className="button-disabled"
                        type="submit"
                      >
                        <img src={timeIcon} size={15} alt="timeIcon" />
                        <small>Tempo</small>
                      </button>
                      <button
                        onClick={() =>
                          handleChangeActivator(trigger._id, 'trigger')
                        }
                        className="button-disabled"
                        type="submit"
                      >
                        <img src={triggerIcon} size={15} alt="triggerIcon" />
                        <small>Gatilho</small>
                      </button>
                    </div>
                  </div>
                </SessionRule>
              ) : null}

              {trigger.activator === 'time' ? (
                <TimeTrigger>
                  <SessionRule>
                    <div className="delete-rule-container">
                      <strong>Regra de sessão {index + 1}:</strong>
                      <img
                        onClick={() => {
                          handleDeleteTrigger(trigger._id);
                        }}
                        src={outlineDelete}
                        size={22}
                        alt="delete-rule"
                      />
                    </div>
                    <div className="activators-container">
                      <small>Ativador</small>
                      <div className="buttons">
                        <button
                          onClick={() =>
                            handleChangeActivator(trigger._id, 'time')
                          }
                          className="button-active"
                          type="submit"
                        >
                          <img src={timeActiveIcon} size={15} alt="timeIcon" />
                          <small>Tempo</small>
                        </button>
                        <button
                          onClick={() =>
                            handleChangeActivator(trigger._id, 'trigger')
                          }
                          className="button-disabled"
                          type="submit"
                        >
                          <img src={triggerIcon} size={15} alt="timeIcon" />
                          <small>Gatilho</small>
                        </button>
                      </div>
                    </div>
                    <TimeSettings>
                      <div className="inactivity-time-container">
                        <small id="start">Após </small>
                        <InputMask
                          onChange={(e) =>
                            handleUpdateTimeInactive(
                              trigger._id,
                              e.target.value
                            )
                          }
                          value={trigger.inactivityTime}
                          placeholder="HH:MM:SS"
                          mask="99:99:99"
                          type="text"
                        />
                        <small> de inatividade</small> <br />
                        <div className="select-container">
                          <small>executa a ação: </small>
                          <Select
                            onChange={(e) => {
                              handleChangeAction(trigger._id, e.value);
                            }}
                            options={selectValue}
                            placeholder={
                              trigger.action === 'message'
                                ? 'Mensagem'
                                : 'Bloco'
                            }
                          />
                        </div>
                        {trigger.action === 'message' ? (
                          <div className="message-container">
                            <strong>Mensagem: </strong>
                            <MenuVariaveis
                              buttonRight="27px"
                              buttonBottom="30px"
                              isTooltip
                              botId={botState._id}
                              onSelect={(variavel) =>
                                handleSelectVariavel(
                                  variavel,
                                  trigger._id,
                                  trigger.message
                                )
                              }
                              id={`bloco-${trigger._id}`}
                            >
                              <textarea
                                placeholder="Digite sua mensagem"
                                id={`desc-${index}-${trigger._id}`}
                                data-id={`desc-${index}-${trigger._id}`}
                                type="text"
                                value={trigger.message}
                                maxLength={300}
                                onChange={(e) => {
                                  handleUpdateMessage(
                                    trigger._id,
                                    e.target.value
                                  );
                                }}
                              />
                            </MenuVariaveis>
                          </div>
                        ) : null}
                        {trigger.action === 'square' ? (
                          <Select
                            placeholder="Selecione..."
                            value={handleFindTimeSelected(trigger.square)}
                            isSearchable
                            options={destinationOptions}
                            onChange={(e) => {
                              handleUpdateSquareSelect(trigger._id, e.value);
                            }}
                          />
                        ) : null}
                      </div>
                    </TimeSettings>
                  </SessionRule>
                </TimeTrigger>
              ) : null}

              {trigger.activator === 'trigger' ? (
                <MessageTrigger>
                  <SessionRule>
                    <div className="delete-rule-container">
                      <strong>Regra de sessão {index + 1}:</strong>
                      <img
                        onClick={() => {
                          handleDeleteTrigger(trigger._id);
                        }}
                        src={outlineDelete}
                        size={22}
                        alt="delete-rule"
                      />
                    </div>

                    <div className="activators-container">
                      <small>Ativador</small>
                      <div className="buttons">
                        <button
                          onClick={() =>
                            handleChangeActivator(trigger._id, 'time')
                          }
                          className="button-disabled"
                          type="submit"
                        >
                          <img src={timeIcon} size={15} alt="timeIcon" />
                          <small>Tempo</small>
                        </button>
                        <button
                          onClick={() =>
                            handleChangeActivator(trigger._id, 'trigger')
                          }
                          className="button-active"
                          type="submit"
                        >
                          <img
                            src={triggerActiveIcon}
                            size={15}
                            alt="timeIcon"
                          />
                          <small>Gatilho</small>
                        </button>
                      </div>
                    </div>
                  </SessionRule>
                  <MessageSettings>
                    <div className="received-message-container">
                      <div className="receive-container">
                        <small id="start">Ao receber: </small>
                        <Select
                          placeholder="Digite uma palavra"
                          inputValue={inputValue[trigger._id]}
                          value={formatValues(trigger.receivedValues)}
                          onInputChange={handleInputChange}
                          onChange={(e) => {
                            handleDeleteWord(trigger._id, e);
                          }}
                          onKeyDown={(e) => {
                            handleKeyDown(trigger._id, e);
                          }}
                          isMulti
                          menuIsOpen={false}
                        />
                      </div>
                      <div className="select-container">
                        <small>executa a ação: </small>
                        <Select
                          onChange={(e) => {
                            handleChangeAction(trigger._id, e.value);
                          }}
                          options={selectValue}
                          placeholder={
                            trigger.action === 'message' ? 'Mensagem' : 'Bloco'
                          }
                        />
                      </div>
                      {trigger.action === 'message' ? (
                        <div className="message-container">
                          <strong>Mensagem: </strong>
                          <MenuVariaveis
                            buttonRight="27px"
                            buttonBottom="30px"
                            isTooltip
                            botId={botState._id}
                            onSelect={(variavel) =>
                              handleSelectVariavel(
                                variavel,
                                trigger._id,
                                trigger.message
                              )
                            }
                            id={`bloco-${trigger._id}`}
                          >
                            <textarea
                              placeholder="Digite sua mensagem"
                              id={`desc-${index}-${trigger._id}`}
                              data-id={`desc-${index}-${trigger._id}`}
                              type="text"
                              value={trigger.message}
                              maxLength={300}
                              onChange={(e) => {
                                handleUpdateMessage(
                                  trigger._id,
                                  e.target.value
                                );
                              }}
                            />
                          </MenuVariaveis>
                        </div>
                      ) : null}
                      {trigger.action === 'square' ? (
                        <Select
                          placeholder="Selecione..."
                          isClearable
                          isSearchable
                          options={destinationOptions}
                          value={handleTriggerFindTimeSelected(trigger.square)}
                          onChange={(e) => {
                            handleUpdateSquareSelect(trigger._id, e.value);
                          }}
                        />
                      ) : null}
                    </div>
                  </MessageSettings>
                </MessageTrigger>
              ) : null}
            </TriggerDetails>
          ))}
      </List>

      <AddRule onClick={() => handleCreateEmptyTrigger()}>
        <img size={22} color="#1384FB" src={outlinePlus} alt="add-rule" />
        <small>adicionar regra de sessão</small>
      </AddRule>

      <Save>
        <button onClick={() => handleSaveBot()} type="submit">
          salvar
        </button>
      </Save>
    </Container>
  );
}

export default SettingsTab;
